import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function TourAddOnsTable() {
  const { t } = useTranslation();
  const name: any = 'approvalable.tourSales.0.tourSaleAddOns';
  const value = HOCWatchValue({ keys: [name] });
  const data = value[name];

  const columns = [
    {
      header: t('common:name'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 250,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  if (!data.length) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={data}
        dispatch={() => {}}
        disabled
        name={name}
      />
      <Separator gap={16} />
    </div>
  );
}
